const constants = Object.freeze({
  ACCESS_TOKEN_PRODUCTION: process.env.ACCESS_TOKEN,
  ACCESS_TOKEN_STAGING: 'ae07dc02942b240d.68351f16154f11950adb70b866b38f13',
  DEFAULT_LOCATION_ID: 'c4fa85cf-2a78-43bc-b9d7-ad5c309c8043',
  AIR_QUALITY_API: 'https://api.ust.is/aq/a/getStations',
  LOCALSTORAGE_ACCESS_TOKEN: 'residentCPanelAccessToken',
  LOCALSTORAGE_ACCOUNT_ID: 'residentCPanelAccountId',
  LOCALSTORAGE_APPLICATION_LANGUAGE: 'residentCPanelApplicationLanguage',
  LOCALSTORAGE_DEVICE_UUID: 'residentCPanelDeviceUUID',
  DATE_FORMAT_DATETIME_SCHEMA: 'YYYY-MM-DDTHH:mm:ss',
  DATE_FORMAT_SEARCH_SCHEMA: 'YY-MM-DD',
  DATE_FORMAT_DATE_SCHEMA: 'YYYY-MM-DD',
  DATE_FORMAT_FULL: 'DD.MM.YY HH:mm',
  DATE_FORMAT_SIMPLE_DATE: 'DD.MM.YY',
  MAX_CREDITS_PURCHASE: 16,
  CARD_WASTE_TYPE: 'waste-collection-credits',
});

export default constants;
